
// We are purposely keeping '.' for decimal values
export const INVALID_CHARACTERS = ['e', 'E', '-', '+'];


export const isInvalidPriceChar = (char: any): boolean => {
    try {
        let parsedValue = parseInt(char);
        return char != '.' && isNaN(parsedValue) || INVALID_CHARACTERS.includes(String(char));
    } catch (exception) {
        return true;
    }
}